import * as z from "zod";

const GraphValueDtoSchema = z.array(z.tuple([z.number(), z.number()]));

export const GraphDtoSchema = z.record(z.string(), GraphValueDtoSchema);
export type GraphDto = z.output<typeof GraphDtoSchema>;
